module.exports = __webpack_public_path__ + "static/media/diving_1920.016832cc.webp";